/* Page motion (7 Sep 2026, final). Founder decision: chapter titles are STATIC — no entrance, no split text,
   no scramble, no parallax — and the scrolled route comet is gone. What remains here:
     1. Alignment: pc-brand-consistency resets h2.pc-section-title to margin:0, which left titles that carry
        their own max-width pinned left inside centred heads; centred heads centre both title and intro.
     2. Pause sync: #PCSignalJourney.is-paused pauses every GSAP animation on the page (proof scene, FAQ Flip).
     3. Magnetic primary CTAs on fine pointers.
   Hero h1 and the finale are untouched. */
(() => {
  if (window.PCSignalMotion) { window.PCSignalMotion.scan(); return; }
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(pointer: fine)');
  const SKIP = '.pcstellar-final, [data-signal-finale], .pcsf__hero';
  const has = n => typeof window[n] !== 'undefined';
  const done = new WeakSet();
  let registered = false;

  function register() {
    if (registered || !has('gsap')) return registered;
    gsap.registerPlugin(...['ScrollTrigger', 'Flip'].filter(has).map(n => window[n]));
    registered = true;
    const host = document.querySelector('#PCSignalJourney');
    if (host) {
      const sync = () => { host.classList.contains('is-paused') ? gsap.globalTimeline.pause() : gsap.globalTimeline.resume(); };
      new MutationObserver(sync).observe(host, { attributes: true, attributeFilter: ['class'] });
      sync();
    }
    return true;
  }

  function align(head, h2) {
    const centred = getComputedStyle(head).textAlign === 'center';
    head.dataset.pcmAlign = centred ? 'center' : 'start';
    if (!centred) return;
    h2.style.marginInline = 'auto';
    const intro = head.querySelector('.pc-section-intro');
    if (intro) intro.style.marginInline = 'auto';
  }

  function prepare(h2) {
    if (done.has(h2) || h2.closest(SKIP)) return;
    done.add(h2);
    const head = h2.parentElement;
    if (!head) return;
    head.classList.add('pcm-head');
    align(head, h2);
  }

  function magnetic(scope) {
    if (!fine.matches || reduced.matches || !has('gsap')) return;
    scope.querySelectorAll('#PCSignalJourney .pc-primary-cta:not(.pcm-magnet)').forEach(btn => {
      btn.classList.add('pcm-magnet');
      btn.addEventListener('pointermove', e => {
        const r = btn.getBoundingClientRect();
        const dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2), dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        gsap.to(btn, { x: dx * 7, y: dy * 4 - 2, duration: .35, ease: 'power3.out', overwrite: 'auto' });
      });
      btn.addEventListener('pointerleave', () => gsap.to(btn, { x: 0, y: 0, duration: .9, ease: 'elastic.out(1, .45)', overwrite: 'auto' }));
    });
  }

  function scan(scope = document) {
    register();
    scope.querySelectorAll('#PCSignalJourney h2.pc-section-title').forEach(prepare);
    magnetic(scope);
  }

  // 2 Nov 2026 speed pass: on the default homepage GSAP is not a <script> tag (theme.liquid passes data-gsap-src).
  // It only powers the magnetic CTA, so it loads after window load or on the first pointer move, whichever is first,
  // and never on coarse pointers or with reduced motion. Other templates still load GSAP themselves.
  const gsapSrc = document.currentScript && document.currentScript.dataset.gsapSrc;
  if (gsapSrc && !has('gsap')) {
    let started = false;
    const go = () => {
      if (started || has('gsap') || !fine.matches || reduced.matches) return;
      started = true;
      removeEventListener('pointermove', go);
      const s = document.createElement('script');
      s.src = gsapSrc; s.async = true; s.setAttribute('data-cfasync', 'false');
      s.onload = () => scan();
      document.head.appendChild(s);
    };
    addEventListener('pointermove', go, { passive: true });
    if (document.readyState === 'complete') setTimeout(go, 0);
    else addEventListener('load', () => setTimeout(go, 0), { once: true });
  }

  document.addEventListener('shopify:section:load', e => scan(e.target));
  window.PCSignalMotion = { scan };
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
})();
